import { render, staticRenderFns } from "./IntroductionWithBenefits.vue?vue&type=template&id=2a36a8fa"
import script from "./IntroductionWithBenefits.vue?vue&type=script&lang=js"
export * from "./IntroductionWithBenefits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports